<template>
  <div
    data-testid="drawer"
    class="pointer-events-auto h-full w-screen max-w-full"
    :class="props.size === 'wide' ? 'sm:max-w-2xl md:max-w-3xl' : 'sm:max-w-lg'"
  >
    <div
      class="flex h-full flex-col overflow-x-hidden overflow-y-auto bg-white py-6 shadow-none sm:shadow-xl"
    >
      <div class="px-4 sm:px-6">
        <div class="flex items-center gap-4">
          <IconButton
            v-if="closeable"
            icon="close"
            variant="neutral"
            @click="drawer.close()"
          />
          <div class="text-base font-semibold text-neutral-900">
            <slot name="title" />
          </div>
        </div>
      </div>
      <div class="relative mt-6 flex-1 px-4 sm:px-6">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { injectOrFail } from '@teachino/shared-util';
import IconButton from '../IconButton/IconButton.vue';
import { drawerKey } from './drawer-key';

const drawer = injectOrFail(drawerKey);

const props = withDefaults(
  defineProps<{
    closeable?: boolean;
    size?: 'default' | 'wide';
  }>(),
  {
    closeable: true,
    size: 'default',
  },
);
</script>
